import React, { useState } from "react"
import PropTypes from "prop-types"
import ClientSprintSummary from "./ClientSprintSummary.controller"
import GeneralSprintProgress from "./GeneralSprintProgress.controller"
import ClientSprintBudgetState from "./ClientSprintBudgetState.controller"
import ClientSprintDetailedEstimation from "./ClientSprintDetailedEstimation.controller"
import { CLIENT_SPRINT_STATES } from "../../../../consts/modules/clientReport.consts"
import { DateTime } from "luxon"

const ClientDevelopment = ({
  refresh,
  triggerRefresh,
  dateRange,
  period,
  sprintData,
}) => {
  const [estimatedPointsFinishDate, setEstimatedPointsFinishDate] =
    useState(null)
  return (
    <div className="flex flex-column gap-3">
      <ClientSprintSummary
        sprintData={sprintData}
        refresh={refresh}
        triggerRefresh={triggerRefresh}
      />
      <div className="flex gap-3 flex-wrap">
        <GeneralSprintProgress
          refresh={refresh}
          sprintData={sprintData}
          setEstimatedPointsFinishDate={setEstimatedPointsFinishDate}
        />
        <ClientSprintBudgetState
          refresh={refresh}
          sprintData={sprintData}
          estimatedPointsFinishDate={estimatedPointsFinishDate}
        />
      </div>
      <ClientSprintDetailedEstimation
        sprintData={sprintData}
        refresh={refresh}
        triggerRefresh={triggerRefresh}
      />
    </div>
  )
}

export default ClientDevelopment

ClientDevelopment.propTypes = {
  refresh: PropTypes.bool.isRequired,
  triggerRefresh: PropTypes.func.isRequired,
  dateRange: PropTypes.arrayOf(PropTypes.instanceOf(DateTime)),
  period: PropTypes.string,
  sprintData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    sprintNumber: PropTypes.number,
    startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    state: PropTypes.oneOf(Object.values(CLIENT_SPRINT_STATES)).isRequired,
    clientConsumptionPeriodType: PropTypes.string.isRequired,
    clientId: PropTypes.number.isRequired,
  }).isRequired,
}
